import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { plainToClass } from 'class-transformer';
import { FormBuilderSectionModel } from '../../models/form-builder-section-model';
import { FormBuilderSeedModel } from '../../models/form-builder-seed-model';
import { ERegistrationStatus, ViewerService } from '../../services/viewer.service';

@Component({
  selector: 'tf-core-fb-form-viewer',
  templateUrl: './tf-fb-form-viewer.component.html',
})
export class TfFbFormViewerComponent implements OnInit {
  @Input() registrationId: string;
  @Input() readonly: boolean;

  @Output() onClose: EventEmitter<null> = new EventEmitter<null>();

  public seed: FormBuilderSeedModel;
  formJson: string;

  constructor(
      private viewerService: ViewerService,
  ) { }

  ngOnInit(): void {
      this.viewerService.getRegistration(this.registrationId).subscribe(
          res => {
            console.log(res);
              if(res.status != ERegistrationStatus.NotStarted) {
                console.log("loading... status: " + res.status)
                this.formJson = res.json;
              }

              let seed = new FormBuilderSeedModel();
              seed.formId = res.version.form.id;
              seed.title = res.version.form.title;
              seed.code = res.version.form.code;
              seed.type = res.version.form.type;
              seed.versionId = res.version.id;
              seed.sections = JSON.parse(res.version.json);
              seed.sections = plainToClass(FormBuilderSectionModel, seed.sections);
              this.seed = seed;
          },
          err => console.log(err),
      ); 
  }

  autoSave(form: FormGroup): void {
    console.table("saving");
    this.viewerService.autoSave({ id: this.registrationId, json: JSON.stringify(form.value) }).subscribe(
      res => console.log("saved"),
      err => console.log(err),
    );
  }

  submit(form: FormGroup): void {
    console.table("submitting");
    this.viewerService.submit({ id: this.registrationId, json: JSON.stringify(form.value) }).subscribe(
      res => {
        console.log("saved");
        this.close()
      },
      err => console.log(err),
    );
  }

  close(): void {
    this.onClose.emit();
  }

}
